import axios from 'axios'

axios.interceptors.request.use((config) => {
  //const token = localStorage.getItem('session')
  const token = process.env.PK
  if (config.url.indexOf("/api/auth/local") < 0) {
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
  }
 
  return config
}, (err) => {
  return Promise.reject(err)
})

axios.interceptors.response.use((response) => {
  return response
}, (err) => {
  console.log(err)
  if (err.response.status === 401) {
    window.$cookies.remove('session')
    location.href = '/'
  }

  if (err.response.status === 400) {
    return err.response.data
  }
  
  return Promise.reject(err)
})
